import React from 'react';
import { withRouter } from 'react-router-dom';

import Unauthenticated from 'Components/Layouts/Unauthenticated';
import AuthLayout from 'Components/Layouts/AuthLayout';
import {FormHandler, Input} from 'Components/Form';
import {Link} from 'Components/Utilities';

import Auth from 'Services/Api/Auth/Auth';
import {translation} from 'Services/TranslationHelpers';

class Login extends React.Component {
    /**
     * @var showPassword
     * @type {boolean}
     */
    showPassword = this.props.location.pathname === '/login/backend';

    /**
     * @method render
     * @return {JSX.Element}
     */
    render() {
        const {form, handleInput, getFieldError, handleSubmit, working, alert} = this.props;

        return (
            <Unauthenticated>
                <AuthLayout
                    title={translation('auth_frontend', 'login')}
                    backLink={window.base.features.allow_password_resets ? "/password/request" : null}
                    backLinkText={translation('auth_frontend', 'forgot_your_password')}
                    submitText={translation('auth_frontend', 'login')}
                    onSubmit={(e) => handleSubmit(e, Auth.login)}
                    working={working}
                    alert={alert}
                >
                    <div className="text-white text-light font-open-sans text-md">
                        <p className="mb-4">
                            Welcome to the Taylor & Francis Awards 2021
                        </p>
                        <p className="mb-8">
                            Join in the celebrations from wherever you are in the world by entering your work email address below.
                        </p>
                    </div>

                    <Input
                        containerClassName="mb-4"
                        label={translation('auth_frontend', 'email')}
                        type="email"
                        value={form.email}
                        error={getFieldError('email')}
                        onChange={v => handleInput('email', v)}
                        whiteStyle={true}
                    />

                    {this.showPassword && (
                        <Input
                            containerClassName="mb-4"
                            label={translation('auth_frontend', 'password')}
                            type="password"
                            value={form.password}
                            error={getFieldError('password')}
                            onChange={v => handleInput('password', v)}
                            whiteStyle={true}
                        />
                    )}
                </AuthLayout>
            </Unauthenticated>
        );
    }
}

export default FormHandler(withRouter(Login));
